import {
  BlockStack,
  Card,
  FormLayout,
  InlineStack,
  Text,
  TextField,
} from '@shopify/polaris';

export interface ContentCardProps {
  title: string;
  body: string;
  titleMax: number;
  bodyMax: number;
  onTitleChange: (v: string) => void;
  onBodyChange: (v: string) => void;
}

export function ContentCard({
  title,
  body,
  titleMax,
  bodyMax,
  onTitleChange,
  onBodyChange,
}: ContentCardProps) {
  return (
    <Card>
      <BlockStack gap="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="h2" variant="headingMd">
            المحتوى
          </Text>
          <Text as="span" variant="bodySm" tone="subdued">
            الخطوة 1 من 4
          </Text>
        </InlineStack>
        <FormLayout>
          <TextField
            label="عنوان الإشعار"
            value={title}
            onChange={onTitleChange}
            autoComplete="off"
            maxLength={titleMax}
            showCharacterCount
            requiredIndicator
            placeholder="مثال: عرض الجمعة — 30% خصم"
            helpText="يفضّل أقل من 50 حرف عشان يظهر كامل في الـ banner"
          />
          <TextField
            label="نص الإشعار"
            value={body}
            onChange={onBodyChange}
            autoComplete="off"
            multiline={3}
            maxLength={bodyMax}
            showCharacterCount
            requiredIndicator
            placeholder="مثال: المضارب اللي بتحبها بأقل أسعار — العرض يستمر لساعتين فقط"
            helpText="iOS هيقطعه بعد ~178 حرف في الـ expanded view"
          />
        </FormLayout>
      </BlockStack>
    </Card>
  );
}
